<template>
  <div>
    <div class="right-title">
      <span>我的业绩</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-date-picker
          v-model="timer"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="setTime">
        </el-date-picker>
        <el-button type="primary" style="margin-left: 10px;" @click="saixuan">筛选</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',color: '#000;'}">
          <el-table-column
            prop="ual_addtime"
            label="日期"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ual_message"
            label="事件"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ual_price"
            label="金额"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>+{{scope.row.ual_price}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <div></div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
              </el-pagination>
            </div>
          </div>
        </div>
        <footerBox class="footer"/>
      </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "yjList",
    data() {
      return {

        timer: '',
        starTime: '',
        endTime: '',
        tableData: [],     // 列表数据
        multipleSelection: [], //  选中的候选人
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1

        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.init()
    },
    methods: {
      //  获取列表
      init() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.start) {
          this.starTime = this.$route.query.start
          this.endTime = this.$route.query.end
          this.timer = [this.$tools.ZHDate(new Date(this.starTime * 1000), 1), this.$tools.ZHDate(new Date(this.endTime * 1000), 1)]
        } else {
          this.starTime = ''
          this.endTime = ''
        }
        this.$api.apiContent.yejiList({
          admin_id: this.user.id,
          xiao: this.starTime,
          da: this.endTime
        }).then(res => {
             loading.close();
          res.data.map(item => {
            item.ual_addtime = this.$tools.ZHDate(new Date(item.ual_addtime * 1000), 1)
          })
          this.tableData = res.data
        }).catch(() => {
             loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })
      },
      //  设置时间
      setTime() {
        if (this.timer) {
          this.starTime = this.timer[0].getTime() / 1000
          this.endTime = this.timer[1].getTime() / 1000
        } else {
          this.starTime = ''
          this.endTime = ''
        }

      },
      //  点击分页
      handleSizeChange(num) {
        this.page.pageNum = num
      },
      //  选择页数
      handleCurrentChange(num) {
        this.page.pageNum = num
      },
      //  搜索
      saixuan() {
        if (this.page.pageNum === 1) {
          this.setPath()
        } else {
          this.page.pageNum = 1
        }
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/yjAdmin/yjList',
          query: {
            pageNum: this.page.pageNum,
            start: this.starTime,
            end: this.endTime

          }
        })
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.init()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;


    .search1 {
      width: 220px;
      position: absolute;
      right: 340px;
      border-radius: 4px !important;
    }

    .search2 {
      width: 220px;
      position: absolute;
      right: 80px;
      border-radius: 4px !important;
    }

    .search3 {
      width: 10px;
      position: absolute;
      right: 317px;
      top: 14px;
    }
  ;

    .btn {
      position: absolute;
      left: 0px;
      padding: 10px 40px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      /*left: 0;*/
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>